import React, { useEffect, useMemo } from 'react'
// import { Link } from "react-router-dom";
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import {
    // getData,
    setTableData,
} from './store/dataSlice'
// import { HiOutlinePencil, HiOutlineTrash } from "react-icons/hi";
// import Tooltip from "components/Ui/Tooltip";
import {
    // ConfirmationModal,
    Table,
} from 'components/Ui'
// import { updateApiRecord, deleteApiRecord } from "services/SalesOrdersService";
// import { Success } from "utils/alerts";
// import useAuth from "utils/hooks/useAuth";
import { carrier, carrierService, orderType, siteLabel, status } from 'components/helper'
injectReducer('salesOrders', reducer)

export default function StockTransactions() {
    const dispatch = useDispatch()
    // const { checkPermission } = useAuth();
    const { data, tableData, loading } = useSelector(state => state.salesOrders.data)

    useEffect(() => {
        // fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
    ])

    //   const fetchData = () =>
    //     dispatch(
    //       getData({ ...tableData, id: user.super_user ? "" : user?.company?.id })
    //     );

    //   const handleDelete = (id) => {
    //     deleteApiRecord(id)
    //       .then(() => {
    //         Success("Deleted Successfully!");
    //         fetchData();
    //       })
    //       .catch((error) => console.log("Error: ", error));
    //   };

    //   const handleStatus = (id, data) => {
    //     delete data.image;
    //     updateApiRecord(id, data)
    //       .then(() => {
    //         Success("Status Updated Successfully!");
    //         fetchData();
    //       })
    //       .catch((error) => console.log("Error: ", error));
    //   };

    const columns = useMemo(
        () => [
            {
                field: 'site',
                header: 'Site',
                className: 'min-w-[150px]',
                renderCell: row => siteLabel(row?.site),
            },
            {
                field: 'client',
                header: 'client',
                className: 'min-w-[150px]',
            },
            {
                field: 'shipment',
                header: 'Shipment',
                className: 'min-w-[150px]',
            },
            {
                field: 'customer',
                header: 'Customer',
                className: 'min-w-[150px]',
            },
            {
                field: 'order_type',
                header: 'Order Type',
                className: 'min-w-[150px]',
                renderCell: row => orderType(row?.order_type),
            },
            {
                field: 'reference_1',
                header: 'Reference 1',
                className: 'min-w-[150px]',
            },
            {
                field: 'reference_2',
                header: 'Reference 2',
                className: 'min-w-[150px]',
            },
            {
                field: 'status',
                header: 'Status',
                className: 'min-w-[200px]',
                renderCell: row => status(row?.status),
            },
            {
                field: 'created_date',
                header: 'Created Date',
                className: 'min-w-[150px]',
            },
            {
                field: 'closed_date',
                header: 'Closed Date',
                className: 'min-w-[150px]',
            },
            {
                field: 'carrier',
                header: 'Carrier',
                className: 'min-w-[200px]',
                renderCell: row => carrier(row?.carrier),
            },
            {
                field: 'carrier_service',
                header: 'Carrier Service',
                className: 'min-w-[150px]',
                renderCell: row => carrierService(row?.carrier_service),
            },
            {
                field: 'tracking',
                header: 'Tracking',
                className: 'min-w-[150px]',
            },
            //   {
            //     header: "Status",
            //     renderCell: (row) => {
            //       return checkPermission("company", "status") ? (
            //         <ConfirmationModal
            //           onConfirm={() => {
            //             handleStatus(row.id, { ...row, is_active: !row.is_active });
            //           }}
            //         >
            //           {status(row.is_active)}
            //         </ConfirmationModal>
            //       ) : (
            //         status(row.is_active)
            //       );
            //     },
            //   },
            //   {
            //     header: "Action",
            //     className: "px-4",
            //     renderCell: (row) => {
            //       return (
            //         <div className="flex items-center gap-3">
            //           {checkPermission("company", "edit") ? (
            //             <Tooltip title={"Edit"}>
            //               <Link
            //                 to={`/company/${row.id}/edit`}
            //                 className="hover:text-primary"
            //               >
            //                 <HiOutlinePencil size={20} />
            //               </Link>
            //             </Tooltip>
            //           ) : null}
            //           {checkPermission("company", "delete") ? (
            //             <Tooltip title={"Delete"}>
            //               <ConfirmationModal
            //                 message={"Are you sure you want to delete this record!"}
            //                 onConfirm={() => {
            //                   handleDelete(row.id);
            //                 }}
            //               >
            //                 <span className="hover:text-danger">
            //                   <HiOutlineTrash size={20} />
            //                 </span>
            //               </ConfirmationModal>
            //             </Tooltip>
            //           ) : null}
            //         </div>
            //       );
            //     },
            //   },
        ],
        // eslint-disable-next-line
        [tableData.sort, tableData.query, tableData.pageIndex, tableData.pageSize, tableData.selectedTab, tableData.checkBox]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Stock Transactions</h2>
            </div>
            <div className="bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <Table
                    loading={loading}
                    filter={false}
                    siteFilter={true}
                    statusFilter={true}
                    carrierFilter={true}
                    clientFilter={true}
                    download={true}
                    datas={data}
                    columns={columns}
                    pagingData={tableData}
                    onChange={e => dispatch(setTableData(e))}
                />
            </div>
        </>
    )
}
